import TitlesProps from "./Props/TitlesProps";
import { CarreiraTitle, imageSlider } from "../data";
import ImageSlider from "./ImageSlider";
import Comments from "./Comments";

function Carreira() {
  return (
    <section className="carreira-container container animate__animated animate__fadeIn">
      <TitlesProps data={CarreiraTitle} />
      <section className="carreira-content">
        {CarreiraTitle.map(({ text }, index) => (
          <div key={index} className="carreira-text">
            <p>{text}</p>
          </div>
        ))}
        <section>
          <ImageSlider data={imageSlider} />
        </section>
      </section>
      <section className="comments-section">
        <Comments />
      </section>
    </section>
  );
}

export default Carreira;
